import { render, staticRenderFns } from "./HigieneSeguridad.vue?vue&type=template&id=b233a18e&"
import script from "./HigieneSeguridad.vue?vue&type=script&lang=js&"
export * from "./HigieneSeguridad.vue?vue&type=script&lang=js&"
import style0 from "./HigieneSeguridad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports